import { Check, X } from 'lucide-react';
import { Button } from '@heroui/react';

interface FilterPopoverFooterProps {
  showReset: boolean;
  onReset: () => void;
  onApply: () => void;
}

export function FilterPopoverFooter({ showReset, onReset, onApply }: FilterPopoverFooterProps) {
  return (
    <>
      {showReset ? (
        <Button variant="danger-soft" onPress={onReset}>
          <X size={16} />
          Limpar filtros
        </Button>
      ) : null}
      <Button variant="primary" onPress={onApply}>
        <Check size={16} />
        Aplicar filtros
      </Button>
    </>
  );
}
